// material-ui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import logo from 'assets/images/logo/icon.png';

// ==============================|| LOGO ICON COMPONENT ||============================== //

export default function LogoIcon({ width = 40, height = 40 }) {
  const theme = useTheme();

  return (
    <Box
      component="img"
      src={logo}
      alt="Logo"
      sx={{
        width: width,
        height: height,
        objectFit: 'contain',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        filter: theme.palette.mode === 'dark' ? 'brightness(0) invert(1)' : 'none',
      }}
    />
  );
}